import LoginPage from '@/components/LoginPage.vue';

const unauthenticatedRoutes = [
  {
    path: '/login',
    component: LoginPage,
    name: 'Login',
    meta: { requiresAuth: false },
  },
  {
    path: '/policies/cookies',
    component: () => import('@/components/CookiePolicy.vue'),
    name: 'Cookie Policy',
    meta: { requiresAuth: false },
  },
  {
    path: '/username/recovery',
    component: () => import('@/components/UsernameRecovery.vue'),
    name: 'Recover Username',
    meta: { requiresAuth: false },
  },
  {
    path: '/password/request',
    component: () => import('@/components/ForgottenPassword.vue'),
    name: 'Forgotten Password',
    meta: { requiresAuth: false },
  },
  {
    path: '/activateuser/:id',
    component: () => import('@/components/ActivateUser.vue'),
    name: 'Activate User',
    meta: { requiresAuth: false },
  },
  {
    path: '/password/reset/:token',
    component: () => import('@/components/ResetPassword.vue'),
    name: 'Reset Password',
    meta: { requiresAuth: false },
  },

];

export default unauthenticatedRoutes;
